import { render, staticRenderFns } from "./CaseStudyBayer.vue?vue&type=template&id=038d7c98&scoped=true"
import script from "./CaseStudyBayer.vue?vue&type=script&lang=js"
export * from "./CaseStudyBayer.vue?vue&type=script&lang=js"
import style0 from "./CaseStudyBayer.vue?vue&type=style&index=0&id=038d7c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d7c98",
  null
  
)

export default component.exports